import ContentPage from './ContentPage'
import ArticleIndexPage from './ArticleIndexPage'
import ArticlePage from './ArticlePage'
import InspirationPage from './InspirationPage'
import ProductPage from './ProductPage'
import HomePage from './HomePage'
import EmailAbbinderPage from './EmailAbbinderPage'
import IndexPage from './IndexPage'
import ProductCategoryPage from './ProductCategoryPage'
import EventLandingPage from './EventLandingPage'

const PageTypesList = {
  article_index_page: ArticleIndexPage,
  article_page: ArticlePage,
  content_page: ContentPage,
  email_abbinder_page: EmailAbbinderPage,
  home_page: HomePage,
  index_page: IndexPage,
  inspiration_page: InspirationPage,
  product_category_page: ProductCategoryPage,
  product_page: ProductPage,
  event_landing_page: EventLandingPage,
}

const PageTypes = (type) => {
  if (typeof PageTypesList[type] === 'undefined') {
    return console.log('page-type not found')
  }
  return PageTypesList[type]
}

export default PageTypes
